import { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Group,
  NumberInput,
  Paper,
  ActionIcon,
} from "@mantine/core";
import { useDebouncedValue, useMediaQuery } from "@mantine/hooks";
import { IoPeopleOutline } from "react-icons/io5";
import AccordionFilterLabel from "../filter-components/AccordionFilterLabel";
import { NumberParam, useQueryParam } from "use-query-params";

const PersonsFilter = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [persons, setPersons] = useQueryParam("persons", NumberParam);
  const [value, setValue] = useState(persons ?? 1);
  const [isChangeTriggered, setChangeTriggered] = useState(false);
  const [debounced] = useDebouncedValue(value, 400);
  const handlers = useRef();

  useEffect(() => {
    if (isChangeTriggered) {
      setPersons(debounced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  const increment = () => {
    setChangeTriggered(true);
    handlers.current.increment();
  };

  const decrement = () => {
    setChangeTriggered(true);
    handlers.current.decrement();
  };

  return (
    <Paper
      shadow={!isMobile ? "sm" : ""}
      p={isMobile ? 0 : "xs"}
      mb={!isMobile ? 15 : ""}
      withBorder
    >
      <Accordion
        defaultValue="Aantal personen"
        variant="filled"
        styles={{ panel: { background: "white" } }}
      >
        <Accordion.Item value="Aantal personen">
          <Accordion.Control>
            <AccordionFilterLabel
              label={"Aantal personen"}
              icon={IoPeopleOutline}
              color="lime"
            />
          </Accordion.Control>
          <Accordion.Panel>
            <Group position="center">
              <ActionIcon
                size={42}
                variant="default"
                onClick={decrement}
                style={{ width: "20%" }}
              >
                –
              </ActionIcon>
              <NumberInput
                hideControls
                value={value}
                onChange={setValue}
                handlersRef={handlers}
                max={70}
                min={1}
                step={1}
                styles={{
                  input: { textAlign: "center" },
                  root: { width: "45%" },
                }}
              />
              <ActionIcon
                size={42}
                variant="default"
                onClick={increment}
                style={{ width: "20%" }}
              >
                +
              </ActionIcon>
            </Group>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Paper>
  );
};

export default PersonsFilter;
